<slideshow [imageUrls]="imageUrlArray" [autoPlay]="true" [minHeight]="'200px'" [height]="height" [showArrows]="false"
  [lazyLoad]="true">
</slideshow>

<ng-container *ngIf="isLoading">
  <app-spinner></app-spinner>
</ng-container>

<ng-container *ngIf="!isLoading">
  <div class="bg-slate-50 " *ngIf="userIsAuthenticated && !isProgressLoading">
    <div class="container" *ngIf="items">
      <p class="py-4 text-center text-4xl tracking-wide font-semibold leading-6 mb-4">Үргэлжлүүлж үзэх
      </p>
      <div class="flex flex-col lg:flex-row flex-wrap ">
        <div
          class=" flex flex-1 lg:max-w-lg min-h-[10em] items-stretch shadow-current ease-in duration-300 rounded hover:-translate-y-3 hover:shadow-3xl-up mb-4 mr-2 cursor-pointer bg-white"
          *ngFor="let item of items" (click)="onClick(item)">
          <div class="flex items-center justify-center  w-1/2 opacity-50 hover:opacity-100 mr-2 rounded "
            [ngStyle]="{'background-image': 'url(' + backendUrl + item.item.cover + ')'} ">
            <mat-icon class="top-1/2 left-1/2 text-4xl w-9 h-9">play_circle_filled</mat-icon>
          </div>
          <div class="w-1/2 p-2">
            <div class=" font-semibold  leading-tight">{{item.item.course.displayName}}</div>
            <!-- <p class="text-gray-500 leading-tight font-thin mt-1 "></p> -->
            <div class=" font-thin mt-2 leading-tight "><b>{{item.item.chapterNumber}}</b>.{{item.item.displayName}}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="container relative">
    <h1 class="pt-4 text-3xl tracking-wide font-semibold leading-6">Шинээр нэмэгдсэн
    </h1>
    <ng-carousel #lateCarouselRef="ngCarousel" [config]="lateUploadCatigoryConfig">
      <ng-template [ngCarouselSlide]="lateCarouselRef" let-item let-active="isActive">
        <app-course-card [imageSource]="backendUrl + item.image" [id]="item.name" [name]="item.displayName"
          [difficulty]="item.difficulty" [price]="item.price" [teacherName]="item.teacher.displayName"
          [teacherImageSource]="backendUrl + item.teacher.profilePic" [teacherTitle]="item.teacher.title"
          [comingSoon]="item.comingSoon" [isPath]="item.isPath" [courseCount]="item.courseCount"
          [paid]="item.orders?.length > 0 && item.orders[0].status !== 'paid'">
        </app-course-card>
      </ng-template>
    </ng-carousel>
    <div class="absolute top-56 left-4 z-2">
      <button mat-fab (click)="lateCarouselRef.prev()" color="white" *ngIf="categoryCourses[0].courses.length > 3 && divWidth > 1024">
        <mat-icon>
          chevron_left
        </mat-icon>
      </button>
    </div>
    <div class="absolute top-56 right-4 z-2">
      <button mat-fab (click)="lateCarouselRef.next()" color="white"  *ngIf="categoryCourses[0].courses.length > 3 && divWidth > 1024">
        <mat-icon>
          chevron_right
        </mat-icon>
      </button>
    </div>
    <div class="flex justify-center pb-3">
      <button class="text-2xl font-semibold h-12 bg-base-color text-white px-3 rounded-xl" routerLink="/explore"
        color="primary">Бүх хичээл
      </button>
    </div>
  </div>
  <div class="bg-slate-50">
    <div class="container relative">
      <h1 class=" pt-4  text-3xl tracking-wide font-semibold leading-6">{{categoryCourses[1].category}}
      </h1>
      <ng-carousel #busnessCarouselRef="ngCarousel" [config]="businessCatigoryConfig">
        <ng-template [ngCarouselSlide]="busnessCarouselRef" let-item let-active="isActive">
          <app-course-card [imageSource]="backendUrl + item.image" [id]="item.name" [name]="item.displayName"
            [difficulty]="item.difficulty" [price]="item.price" [teacherName]="item.teacher.displayName"
            [teacherImageSource]="backendUrl + item.teacher.profilePic" [teacherTitle]="item.teacher.title"
            [comingSoon]="item.comingSoon" [isPath]="item.isPath" [courseCount]="item.courseCount"
            [paid]="item.orders?.length > 0 && item.orders[0].status !== 'paid'">
          </app-course-card>
        </ng-template>
      </ng-carousel>
      <div class="absolute top-56  left-4  z-3" *ngIf="categoryCourses[1].courses.length > 3 && divWidth > 1024">
        <button mat-fab (click)="busnessCarouselRef.prev()" color="white">
          <mat-icon>
            chevron_left
          </mat-icon>
        </button>
      </div>
      <div class="absolute top-56 right-4  z-3" *ngIf="categoryCourses[1].courses.length > 3 && divWidth > 1024">
        <button mat-fab (click)="busnessCarouselRef.next()" color="white">
          <mat-icon>
            chevron_right
          </mat-icon>
        </button>
      </div>
    </div>
  </div>
  <div class="container relative">
    <h1 class="pt-4  text-3xl tracking-wide font-semibold leading-6">{{categoryCourses[2].category}}
    </h1>
    <ng-carousel #programmingCarouselRef="ngCarousel" [config]="programmingCatigoryConfig">
      <ng-template [ngCarouselSlide]="programmingCarouselRef" let-item let-active="isActive">
        <app-course-card [imageSource]="backendUrl + item.image" [id]="item.name" [name]="item.displayName"
          [difficulty]="item.difficulty" [price]="item.price" [teacherName]="item.teacher.displayName"
          [teacherImageSource]="backendUrl + item.teacher.profilePic" [teacherTitle]="item.teacher.title"
          [comingSoon]="item.comingSoon" [isPath]="item.isPath" [courseCount]="item.courseCount"
          [paid]="item.orders?.length > 0 && item.orders[0].status !== 'paid'">
        </app-course-card>
      </ng-template>
    </ng-carousel>
    <div class="absolute top-56  left-4  z-4">
      <button mat-fab (click)="programmingCarouselRef.prev()" color="white" *ngIf="categoryCourses[2].courses.length > 3 && divWidth > 1024">
        <mat-icon>
          chevron_left
        </mat-icon>
      </button>
    </div>
    <div class="absolute top-56 right-4  z-4">
      <button mat-fab (click)="programmingCarouselRef.next()" color="white" *ngIf="categoryCourses[2].courses.length > 3 && divWidth > 1024">
        <mat-icon>
          chevron_right
        </mat-icon>
      </button>
    </div>
  </div>
  <div class="bg-slate-50">
    <div class="container relative">
      <h1 class="pt-4  text-3xl tracking-wide font-semibold leading-6">{{categoryCourses[3].category}}
      </h1>
      <ng-carousel #officeCarouselRef="ngCarousel" [config]="officeCatigoryConfig">
        <ng-template [ngCarouselSlide]="officeCarouselRef" let-item let-active="isActive">
          <app-course-card [imageSource]="backendUrl + item.image" [id]="item.name" [name]="item.displayName"
            [difficulty]="item.difficulty" [price]="item.price" [teacherName]="item.teacher.displayName"
            [teacherImageSource]="backendUrl + item.teacher.profilePic" [teacherTitle]="item.teacher.title"
            [comingSoon]="item.comingSoon" [isPath]="item.isPath" [courseCount]="item.courseCount"
            [paid]="item.orders?.length > 0 && item.orders[0].status !== 'paid'">
          </app-course-card>
        </ng-template>
      </ng-carousel>
      <div class="absolute top-56  left-4  z-5">
        <button mat-fab (click)="officeCarouselRef.prev()" color="white" *ngIf="categoryCourses[3].courses.length > 3 && divWidth > 1024">
          <mat-icon>
            chevron_left
          </mat-icon>
        </button>
      </div>
      <div class="absolute top-56 right-4  z-5">
        <button mat-fab (click)="officeCarouselRef.next()" color="white" *ngIf="categoryCourses[3].courses.length > 3 && divWidth > 1024">
          <mat-icon>
            chevron_right
          </mat-icon>
        </button>
      </div>
    </div>
  </div>
  <div class="container relative">
    <h1 class="pt-4  text-3xl tracking-wide font-semibold leading-6">{{categoryCourses[4].category}}
    </h1>
    <ng-carousel #marketingCarouselRef="ngCarousel" [config]="marketingCatigoryConfig">
      <ng-template [ngCarouselSlide]="marketingCarouselRef" let-item let-active="isActive">
        <app-course-card [imageSource]="backendUrl + item.image" [id]="item.name" [name]="item.displayName"
          [difficulty]="item.difficulty" [price]="item.price" [teacherName]="item.teacher.displayName"
          [teacherImageSource]="backendUrl + item.teacher.profilePic" [teacherTitle]="item.teacher.title"
          [comingSoon]="item.comingSoon" [isPath]="item.isPath" [courseCount]="item.courseCount"
          [paid]="item.orders?.length > 0 && item.orders[0].status !== 'paid'">
        </app-course-card>
      </ng-template>
    </ng-carousel>
    <div class="absolute top-56  left-4  z-6">
      <button mat-fab (click)="marketingCarouselRef.prev()" color="white" *ngIf="categoryCourses[4].courses.length > 3 && divWidth > 1024">
        <mat-icon>
          chevron_left
        </mat-icon>
      </button>
    </div>
    <div class="absolute top-56 right-4  z-6">
      <button mat-fab (click)="marketingCarouselRef.next()" color="white" *ngIf="categoryCourses[4].courses.length > 3 && divWidth > 1024">
        <mat-icon>
          chevron_right
        </mat-icon>
      </button>
    </div>
  </div>
  <div class="bg-slate-50">
    <div class="container relative">
      <h1 class="pt-4  text-3xl tracking-wide font-semibold leading-6">Багц хичээлүүд
      </h1>
      <ng-carousel #packageCarouselRef="ngCarousel" [config]="packageCatigoryConfig">
        <ng-template [ngCarouselSlide]="packageCarouselRef" let-item let-active="isActive">
          <app-course-card [imageSource]="backendUrl + item.image" [id]="item.name" [name]="item.displayName"
            [difficulty]="item.difficulty" [price]="item.price" [teacherName]="item.teacher.displayName"
            [teacherImageSource]="backendUrl + item.teacher.profilePic" [teacherTitle]="item.teacher.title"
            [comingSoon]="item.comingSoon" [isPath]="item.isPath" [courseCount]="item.courseCount"
            [paid]="item.orders?.length > 0 && item.orders[0].status !== 'paid'">
          </app-course-card>
        </ng-template>
      </ng-carousel>
      <div class="absolute top-56  left-4  z-2">
        <button mat-fab (click)="packageCarouselRef.prev()" color="white" *ngIf="categoryCourses[5].courses.length > 3 && divWidth > 1024">
          <mat-icon>
            chevron_left
          </mat-icon>
        </button>
      </div>
      <div class="absolute top-56 right-4  z-2">
        <button mat-fab (click)="packageCarouselRef.next()" color="white" *ngIf="categoryCourses[5].courses.length > 3 && divWidth > 1024">
          <mat-icon>
            chevron_right
          </mat-icon>
        </button>
      </div>
    </div>
  </div>

  <div class="container">
    <h1 class="pt-4  text-3xl tracking-wide font-semibold leading-6">Classes taught by Professionals
    </h1>
    <ng-carousel #carouselRef="ngCarousel" [config]="teacherConfig">
      <ng-template [ngCarouselSlide]="carouselRef" let-item let-active="isActive"
        let-activeOnTheRight="activeOnTheRight" let-activeOnTheLeft="activeOnTheLeft">
        <app-teacher-card [displayName]="item.displayName" [teacherImageSource]="item.profilePic" [name]="item.name"
          [title]="item.title">
        </app-teacher-card>
      </ng-template>
    </ng-carousel>
  </div>

</ng-container>
